import { useAxios } from '@/context/axiosContext'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BoardTitle, MainBoardWrapper } from '../board/mainBoard'
import { SurveyData, SurveyGroupData } from '@/pages/survey/surveyItem'
import styled from 'styled-components'
import './mainSurvey.css'
import { useResponsive } from '@/hooks/useResponsive'

export const MainSurvey = () => {
  const axios = useAxios()
  const navigate = useNavigate()

  const [survey, setSurvey] = useState<SurveyGroupData[]>([])
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const getSurvey = async () => {
    const response = await axios.get('/survey/getSurveyList')
    if (response.status == 200) {
      const surveyList = response.data.data.surveyList

      if (surveyList && Array.isArray(surveyList)) {
        const groupedSurveys: SurveyGroupData[] = Object.values(
          surveyList.reduce(
            (acc, item) => {
              const {
                cmpnyCd,
                regId,
                regDate,
                updId,
                updDate,
                surveySn,
                surveyTitle,
                surveyDesc,
                surveyStartDate,
                surveyEndDate,
                isAnonymous,
                isMultiple,
                maxChoices,
                optionSn,
                optionTitle,
                optionDesc,
                surveyCount,
                surveyActive,
                totalVoters,
                useYn,
                delYn,
                userOptionSn,
                votePercent,
              } = item

              if (!acc[surveySn]) {
                acc[surveySn] = {
                  cmpnyCd,
                  regId,
                  regDate,
                  updId,
                  updDate,
                  surveySn,
                  surveyTitle,
                  surveyDesc,
                  surveyStartDate,
                  surveyEndDate,
                  isAnonymous,
                  isMultiple,
                  maxChoices,
                  surveyActive,
                  useYn,
                  delYn,
                  userOptionSn,
                  totalVoters,
                  votePercent,
                  options: [], // ✅ 여기서만 options 관리
                }
              }

              acc[surveySn].options.push({
                surveySn,
                optionSn,
                optionTitle,
                optionDesc,
                surveyCount,
                votePercent,
                userOptionSn,
              })

              return acc
            },
            {} as Record<number, SurveyGroupData>,
          ),
        )
        const activeList = groupedSurveys.filter(
          (item: SurveyGroupData) => item.surveyActive == 'Y',
        )
        setSurvey(activeList) // 최신순
      }
    } else {
    }
  }

  const getRemainingTime = (endDate: string) => {
    const now = new Date() // 현재 시간
    const end = new Date(endDate) // 종료 시간
    const diffMs = end.getTime() - now.getTime() // 밀리초 차이

    if (diffMs <= 0) return '투표 종료' // 종료된 경우

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24)) // 남은 일수
    const diffHours = Math.floor(
      (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    ) // 남은 시간

    return `${diffDays}일 ${diffHours}시간 남음`
  }

  useEffect(() => {
    getSurvey()
  }, [])

  const moveSurvey = () => {
    window.scrollTo(0, 0)
    navigate(`/survey`)
  }

  const getSurveyStatusLabel = (surveyActive: string): string => {
    const mapping: { [key: string]: string } = {
      Y: '진행중',
      N: '종료',
    }

    return mapping[surveyActive] || '[투표 종료]' // 기본값으로 [투표 종료] 반환
  }

  const formatDate = (dateString: string, isDetail = false) => {
    if (!dateString) return ''

    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')

    const now = new Date()
    const isToday =
      year === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      day === now.getDate().toString().padStart(2, '0')

    // 상세(detail) 페이지일 경우 항상 yyyy.MM.dd hh:mm:ss 형식
    if (isDetail) {
      return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`
    }

    // 오늘 날짜인 경우에도 yyyy.MM.dd 형식으로 출력
    return `${year}.${month}.${day}`
  }
  return (
    <div className="main-survey-card" onClick={moveSurvey}>
      <div className="main-survey-card-header">
        <div className="main-survey-card-title">투표</div>
        <div
          style={{
            fontSize: '13px',
            color: '#888888',
            fontWeight: 'normal',
          }}
        >
          {'더보기'}
        </div>
      </div>

      {survey && survey.length > 0 ? (
        <>
          {!isMobile ? (
            <>
              <div className="main-survey-card-content">
                <p className="main-survey-card-subtitle">
                  {survey[0].surveyTitle}
                </p>
                <p className="main-survey-card-desc">{survey[0]?.surveyDesc}</p>
              </div>

              <div className="main-survey-card-footer">
                <div className="main-survey-card-status">
                  <div className="main-survey-card-status-indicator"></div>
                  <span className="main-survey-card-status-text">
                    <strong>{survey[0].totalVoters || 0}명</strong> 참여중
                  </span>
                </div>
                <span className="main-survey-card-timer">
                  {getRemainingTime(survey[0].surveyEndDate)}
                </span>
              </div>
            </>
          ) : (
            <>
              <section
                className={`${survey[0].surveyActive === 'Y' ? 'mobile-survey-current-poll' : 'mobile-survey-end-poll'}`}
                style={{ marginBottom: '5px' }}
              >
                <div className="mobile-survey-poll-header">
                  <span
                    className={`${survey[0].surveyActive === 'Y' ? 'mobile-survey-poll-status' : 'mobile-survey-end-status'}`}
                  >
                    {getSurveyStatusLabel(survey[0].surveyActive)}
                  </span>
                  <span className="mobile-survey-poll-meta">
                    {`${getRemainingTime(survey[0].surveyEndDate)} | 투표 인원 : ${survey[0].totalVoters}명`}
                  </span>
                </div>

                {/* 설문 내용 - active 클래스로 show/hide 제어 */}
                <div
                  className={`mobile-survey-content ${survey[0].surveyActive ? 'active' : ''}`}
                >
                  <div className="mobile-survey-poll-question">
                    {survey[0].surveyTitle}
                  </div>
                  <div className="mobile-survey-poll-description">
                    {survey[0].surveyDesc}
                  </div>
                  <div className="mobile-survey-poll-period">
                    {`투표기간 : ${formatDate(survey[0].surveyStartDate)} - ${formatDate(survey[0].surveyEndDate)}`}
                  </div>
                </div>
              </section>
            </>
          )}
        </>
      ) : (
        <div className="main-survey-card-empty">
          <div className="main-survey-card-empty-icon">
            <svg
              className="w-8 h-8 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
          </div>
          <p className="main-survey-card-empty-text">
            진행중인 투표가 없습니다
          </p>
        </div>
      )}
    </div>
  )
}

export const MainSurveyWrapper = styled.div`
  border: 1px solid #ddd;
  padding: 12px 15px 12px 12px;
  border-radius: 8px;
  width: 100%;
  border-bottom: 1px solid #ddd; /* 테두리 유지 */
  box-sizing: border-box; /* padding이 border에 포함되도록 설정 */
  flex: 1; /* 남는 높이 없게끔 가져가기 */
`
